const invalidKeys = ['key'];

export const setCamposPersonalizados = (original, camposPersonalizados) => {
  if (!camposPersonalizados) {
    return original;
  }

  const compra = { ...original };

  const filteredKeys = Object.keys(camposPersonalizados).filter(key => !invalidKeys.includes(key));

  filteredKeys.forEach((key) => {
    if (!camposPersonalizados[key].isProduto) {
      compra[key] = camposPersonalizados[key].valorPadrao;
    }
  });
  return compra;
};

export const buildFiltroCampoPersonalizado = (key, campoPersonalizado, filterValue) => {
  const param = campoPersonalizado.isProduto ? `produto.${key}` : key;

  if (campoPersonalizado.stringFilter) {
    return `${param} like '%${filterValue}%'`;
  }
  return `${param}=${filterValue}`;
};

export const buildFiltrosCamposPersonalizados = (camposPersonalizados, filterValue) => {
  if (!camposPersonalizados) {
    return '';
  }

  const filters = [];
  const keys = Object.keys(camposPersonalizados).filter(key => !invalidKeys.includes(key));

  keys.forEach((key) => {
    if (camposPersonalizados[key].hasFilter) {
      filters.push(buildFiltroCampoPersonalizado(key, camposPersonalizados[key], filterValue));
    }
  });

  if (!filters.length) {
    return '';
  }

  return `(${filters.join(' and ')})`;
};

export default {
  setCamposPersonalizados,
  buildFiltrosCamposPersonalizados,
};
